import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlank = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
});
export default SvgBlank;
